import type { ReactNode } from 'react';
import { cn } from '@/shared/helpers/cn';
import styles from './Badge.module.scss';

export type BadgeTone = 'brand' | 'success' | 'warning' | 'danger' | 'neutral';

export interface BadgeProps {
  tone?: BadgeTone;
  /** `soft` usa tint + texto na cor cheia; `solid` usa a cor cheia + texto branco. */
  variant?: 'soft' | 'solid';
  children: ReactNode;
  className?: string;
}

/**
 * Pill de status.
 *
 * O rotulo textual e obrigatorio: em tabela, "Sim/Não" e o estado do agendamento
 * precisam da palavra alem do fundo, porque cor sozinha nao sobrevive a
 * daltonismo nem a monitor de consultorio.
 */
export function Badge({ tone = 'neutral', variant = 'soft', children, className }: BadgeProps) {
  return <span className={cn(styles.badge, styles[tone], styles[variant], className)}>{children}</span>;
}
